module.exports = __webpack_public_path__ + "media/images/webpage/hotels/4460/floorguide/course-3-photo-3-17c3feae0e0df344f53b5862605c39b0.webp";